import cn from 'clsx';
import Currency from '@v2/shared/components/Currency';
import { ProductType, Sku } from '@v2/shared/lib/types';
import { useSite } from '@v2/shared/lib/site';
import useProductPriceLogic from '@v2/shared/lib/useProductPriceLogic';

type MsrpProps = {
  sku: Sku;
  productType: ProductType;
  showLabel?: boolean;
  className?: string;
};

export default function Msrp({ sku, productType, showLabel, className }: MsrpProps) {
  const site = useSite();
  const { showMsrp } = useProductPriceLogic(sku);
  if (!showMsrp) return null;

  const label = `${productType === ProductType.TYPE_MAGAZINE ? 'Cover' : 'List'} price:`;

  return (
    <span className={cn('font-medium text-slate-500', className)}>
      {showLabel && <span className="mr-1">{label}</span>}
      <span className="line-through">
        <Currency value={sku.msrp} currencyCode={site.currency} />
      </span>
    </span>
  );
}
